import { render, staticRenderFns } from "./CompanyCertification.vue?vue&type=template&id=25b1e215&scoped=true"
import script from "./CompanyCertification.vue?vue&type=script&lang=js"
export * from "./CompanyCertification.vue?vue&type=script&lang=js"
import style0 from "./CompanyCertification.vue?vue&type=style&index=0&id=25b1e215&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b1e215",
  null
  
)

export default component.exports